import { SetSectionPropertiesMutation } from '../mutation/section/set-section-properties-mutation';
import { record } from '../utils/recorder';
import { MutationAPI } from './mutation-api';
import type { ISectionData } from '../data';
import type { SectionDataModel } from '../model/section-data-model';

export class SectionMutationAPI extends MutationAPI<SectionDataModel> {
    /**
     * 更新节属性
     */
    @record()
    public updateProps({ name }: Pick<ISectionData, 'name'>) {
        this.transaction(() => {
            if (this.model.props.name !== name) {
                this.request([new SetSectionPropertiesMutation({ sectionId: this.model.id, name })]);
            }
        });
    }
}
